export default __webpack_public_path__ + "static/media/logo-header.88a3b1ea.png";